<template>
  <div class="goldenegg-log-box">
    <!-- 操作栏 -->
    <div class="action-bar">
      <el-select
        v-model="params.activityId"
        size="small"
        placeholder="请选择活动"
        clearable
      >
        <el-option
          v-for="item in actIDs"
          :value="item.value"
          :label="item.label"
          :key="item.value"
        ></el-option>
      </el-select>
      <el-select
        v-model="params.vipCardId"
        size="small"
        placeholder="请选择会员卡"
        clearable
      >
        <el-option
          v-for="item in vipCardIds"
          :value="item.value"
          :label="item.label"
          :key="item.value"
        ></el-option>
      </el-select>
      <!-- <el-input
        placeholder="活动ID"
        v-model.number="params.activityId"
        clearable
        size="small"
        @keyup.enter.native="getWinRecord()"
        class="param-input"
      ></el-input>
      <el-input
        placeholder="用户ID"
        v-model.number="params.uid"
        clearable
        size="small"
        @keyup.enter.native="getWinRecord()"
        class="param-input"
      ></el-input> -->
      <el-button type="primary" size="small" @click="getWinRecord('status')"
        >搜索</el-button
      >
    </div>
    <!-- 表格数据 -->
    <el-table
      :data="tableData"
      border
      height="600"
      v-loading="loading"
      element-loading-text="拼命加载中"
      element-loading-spinner="el-icon-loading"
    >
      <!-- <el-table-column
        prop="id"
        label="ID"
        align="center"
        :show-overflow-tooltip="true"
        width="200"
      >
        <template slot-scope="scope">
          <span>{{ scope.row.id || '未知' }}</span>
        </template>
      </el-table-column> -->
      <el-table-column
        prop="uid"
        label="用户ID"
        align="center"
        :show-overflow-tooltip="true"
        min-width="120"
      />
      <el-table-column
        prop="activityId"
        min-width="160"
        label="活动"
        align="center"
        :show-overflow-tooltip="true"
      >
        <template slot-scope="scope">
          <span> {{ formatterAct(scope.row.activityId) }}</span>
        </template>
      </el-table-column>
      <el-table-column
        prop="name"
        label="奖品名称"
        align="center"
        min-width="120"
      />
      <el-table-column
        prop="type"
        label="奖品类型"
        align="center"
        min-width="110"
      >
        <template slot-scope="scope">
          <span>{{ scope.row.type | prizeTypes }}</span>
        </template>
      </el-table-column>
      <el-table-column
        prop="level"
        label="奖品等级"
        align="center"
        min-width="150"
        :formatter="levelFormatter"
      />
      <el-table-column
        prop="count"
        label="奖品数量"
        align="center"
        min-width="120"
      />
      <el-table-column
        prop="price"
        label="奖品价值"
        align="center"
        min-width="150"
      />
      <el-table-column
        prop="value"
        label="折扣率/活跃值"
        align="center"
        min-width="150"
      />
      <el-table-column
        prop="drawPrice"
        label="单次抽奖价格(金币)"
        align="center"
        min-width="150"
      />
      <el-table-column
        prop="vipCardId"
        min-width="160"
        label="会员卡"
        align="center"
        :show-overflow-tooltip="true"
      >
        <template slot-scope="scope">
          <span> {{ formatterVip(scope.row.vipCardId) }}</span>
        </template>
      </el-table-column>

      <el-table-column
        prop="createdAt"
        label="创建时间"
        align="center"
        min-width="220"
      >
        <template slot-scope="scope">
          <span>{{ scope.row.createTime | changeDate }}</span>
        </template>
      </el-table-column>
    </el-table>
    <!--分页组件-->
    <el-pagination
      :page-sizes="[5, 10, 15, 20]"
      :current-page="params.pageNumber"
      :page-size="params.pageSize"
      layout="total, sizes, prev, pager, next, jumper"
      background
      @size-change="changeSize"
      :total="total"
      v-if="total > 10"
      @current-change="changeCurrent"
    ></el-pagination>
  </div>
</template>
<script>
import API from "@/api";
import baseConfig from "@/utils/serverUrlConfig";
export default {
  data() {
    return {
      imgUrl: baseConfig.imgUrl,
      tableData: [],
      loading: false,
      total: "",
      params: {
        uid: "",
        activityId: "",
        // prizeName: '',
        pageNumber: 1,
        pageSize: 10,
      },
      vipCardIds: [],
      actIDs: [],
      prizeNameList: [],
    };
  },
  filters: {
    prizeTypes(val) {
      const ruleObj = {
        1: "活跃值",
        2: "金币",
        3: "棋牌金币",
        4: "楼凤解锁折扣",
        5: "会员卡",
        6: "会员折扣卷",
        7: "实物",
        8: "积分",
      };
      return ruleObj[val] || "未知";
    },
  },
  created() {
    this.getWinRecord();
    this.getActiveityId();
    // this.getPrizeNames()
    this.getVipcardId();
  },
  methods: {
    // 请求砸蛋活动日志列表
    getWinRecord() {
      this.loading = true;
      API.getWinRecord(this.params)
        .then((res) => {
          // eslint-disable-next-line no-console
          // console.log(this.tableData, 'res')
          if (res.code === 200 && res.data.list) {
            this.tableData = res.data.list;
            this.total = res.data.count;
          } else {
            this.tableData = [];
            this.total = 0;
          }
          this.loading = false;
        })
        .catch(() => {
          this.tableData = [];
          this.loading = false;
        });
    },
    // 获取奖品名称
    async getPrizeNames() {
      const res = await API.getPrizeNames();
      try {
        if (res.code === 200 && res.data) {
          this.prizeNameList = res.data;
        } else {
          this.prizeNameList = [];
        }
      } catch (error) {
        // eslint-disable-next-line no-console
        console.log(error);
      }
    },
    // pageSize发生变化触发
    changeSize(size) {
      this.params.pageSize = size;
      this.params.pageNumber = 1;
      this.getWinRecord();
    },
    // 当前页发生变化触发
    changeCurrent(pageNumber) {
      this.params.pageNumber = pageNumber;
      this.getWinRecord();
    },
    // 活动
    formatterAct(id) {
      return this.actIDs.filter((item) => item.value == id).length > 0
        ? this.actIDs.filter((item) => item.value == id)[0].label
        : "未知";
    },
    // 会员卡
    formatterVip(id) {
      return this.vipCardIds.filter((item) => item.value == id).length > 0
        ? this.vipCardIds.filter((item) => item.value == id)[0].label
        : "-";
    },
    // 奖品等级
    levelFormatter(row) {
      let str = "-";
      switch (row.level) {
        case 1:
          str = "初级";
          break;
        case 2:
          str = "中级";
          break;
        case 3:
          str = "高级";
          break;
        default:
          break;
      }
      return str;
    },
    // 获取活动ID
    getActiveityId() {
      API.getActiveityId(this.params).then((res) => {
        if (res.code === 200 && res.data) {
          this.actIDs = res.data;
          return;
        }
        this.$message.error("获取活动失败");
      });
    },
    // 获取VIP ID
    getVipcardId() {
      API.getVipcardId(this.params).then((res) => {
        if (res.code === 200 && res.data) {
          this.vipCardIds = res.data;
          return;
        }
        this.$message.error("获取会员卡失败");
      });
    },
  },
};
</script>
<style scoped></style>
